import './guide.css';
import CatalogueBrowser from './CatalogueBrowser.svelte';
import RoleReadings from './RoleReadings.svelte';
import { collectionFor } from './collections.js';

function parseData(element) {
    if (!element) return {};
    try {
        return JSON.parse(element.textContent);
    } catch (_error) {
        return {};
    }
}

const target = document.getElementById('guide-browser');
let app = null;

if (target) {
    const data = parseData(document.getElementById('guide-data'));
    const name = target.getAttribute('data-collection') || 'roles';
    const entries = data[name] || [];

    const facetId = target.getAttribute('data-facet-id');
    const facetValue = target.getAttribute('data-facet-value');

    if (entries.length > 0) {
        app = new CatalogueBrowser({
            target,
            props: {
                collection: collectionFor(name, data),
                entries,
                initialFacet: facetId && facetValue ? { id: facetId, value: facetValue } : null,
            },
        });

        const fallback = document.getElementById('guide-fallback');
        if (fallback) {
            fallback.hidden = true;
        }
    }
}

// The role page server-renders the readings table so crawlers and no-JS readers get it. The
// component renders the same baseline plus a picker, so once it has mounted the static copy is
// hidden rather than left to say the same thing twice. Mounting is still conditional because a
// role with nothing on offer would get a control with an empty menu.
const readingsTarget = document.getElementById('guide-readings-app');

if (readingsTarget) {
    const effects = parseData(document.getElementById('guide-hypothetical-data'));

    if ((effects.items || []).length > 0 || (effects.auras || []).length > 0) {
        new RoleReadings({
            target: readingsTarget,
            props: {
                effects,
                roleName: readingsTarget.getAttribute('data-role-name') || 'role',
                roleSlug: readingsTarget.getAttribute('data-role-slug') || '',
            },
        });

        const staticReadings = document.getElementById('guide-readings-static');
        if (staticReadings) {
            staticReadings.hidden = true;
        }
    }
}

export default app;
